/* eslint-disable rover/no-platform-specific-globals-or-imports */
import React, { useEffect } from 'react';

export default function useOnClickOutside(
  ref: React.RefObject<HTMLDivElement | null>,
  handler: (event) => void
): void {
  useEffect(() => {
    const listener = (event): void => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('touchstart', listener);
    document.addEventListener('mousedown', listener);
    return (): void => {
      document.removeEventListener('touchstart', listener);
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler]);
}
